import { useHistory } from 'react-router-dom';

export default function HomeComponent({ showAdmin, onOpenWorkerSheet }) {
    const history = useHistory();

    return (
        <div className="home-page">
            <h1>Маск Эскорт</h1>
            <p className="subtitle">Элитное агентство для успешных мужчин</p>
            <button className="btn-primary" onClick={() => history.push('/models')}>
                Смотреть модели
            </button>
            {showAdmin && (
                <button
                    className="worker-gear-btn"
                    onClick={onOpenWorkerSheet}
                    title="Панель воркера"
                >
                    ⚙
                </button>
            )}
        </div>
    );
}
